export const SET_OVERVIEW = "member/SET_OVERVIEW";
export const SET_COLLECTION = "member/SET_COLLECTION";
export const MARK_WATCHED = "member/MARK_WATCHED";
export const SET_MEMBERSHIP = "member/SET_MEMBERSHIP";
